import { Classroom360Service } from './../../classroom360/classroom360.service';
import { Portal } from './../../shared-components/portal.model';
import { Component, OnInit, ChangeDetectionStrategy, ViewChild, OnDestroy } from '@angular/core';
import { CalendarService } from './calendar.service';
import { StudentService } from '../../shared-components/student/student.service';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { CalendarDayViewComponent, CalendarEvent } from 'angular-calendar';
import { Subject } from 'rxjs';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CalendarEventModalComponent } from './calendar-event-modal/calendar-event-modal.component';
import { Student360Service } from '../student360.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { SharedGradebookService } from '../../classroom360/gradebook/shared/shared-gradebook.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit, OnDestroy {

    @ViewChild(CalendarDayViewComponent) dayView;
    @ViewChild(CalendarHeaderComponent, { static: true }) calendarHeader;
    calendarEventDialogRef: MatDialogRef<CalendarEventModalComponent>;
    view: any = 'day';
    viewDate: Date = new Date(); // Controls the view of the calendar
    events: CalendarEvent[] = [];
    refresh: Subject<any> = new Subject();
    selectedDate: Date;
    currentDate: Date;
    attendanceCodes: any[];
    selectedMonth: string;
    selectedDay: number;
    selectedYear: number;
    dateIndex: number;
    selectedView: string;
    courses: any;
    studentId: number;
    studentCalendar: any[];
    scalePDF = 0.40;

    constructor(
        private activatedRoute: ActivatedRoute,
        private student360Service: Student360Service,
        private calendarService: CalendarService,
        private dialog: MatDialog,
        private studentService: StudentService,
        private yearService: YearService,
        private router: Router, private userService: UserService,
        private loginService: LoginService,
        private sharedGradebookService: SharedGradebookService,
        private classroom360Service: Classroom360Service
    ) {
        if (!!this.student360Service.lastSelectedCalendarView) {
            this.selectedDate = this.student360Service.lastSelectedCalendarDate;
        } else {
            this.selectedDate = new Date();
            this.activatedRoute.queryParams.subscribe(params => {
                const selectedView = params['selectedView'];
                const selectedDate = params['selectedDate'];
                if (selectedView) {
                    this.view = selectedView;
                }
                if (selectedDate) {
                    this.selectedDate = new Date(selectedDate);
                    this.viewDate = this.selectedDate;
                }
            });
        }
        this.currentDate = new Date();
        this.selectedDay = this.currentDate.getDate();
        this.selectedYear = this.selectedDate.getFullYear();
        this.studentId = this.studentService.selectedStudent.Id;
        this.getCalendarEvents();
    }

    ngOnInit() {
        if (!!this.student360Service.lastSelectedCalendarView) {
            this.view = this.student360Service.lastSelectedCalendarView;
        }
        if (!!this.student360Service.lastSelectedCalendarDate) {
            if (this.selectedDate == this.student360Service.lastSelectedCalendarDate) {
                this.viewDate = this.student360Service.lastSelectedCalendarDate;
            }
        }
        this.studentService.selectedStudentStream$.subscribe(student => {
            if (this.studentId != this.studentService.selectedStudent.Id) {
                this.studentId = this.studentService.selectedStudent.Id;
                this.getCalendarEvents();
            }
        });
        this.calendarHeader.viewChange.subscribe(res => {
            // Do view Change stuff
            const previousView = _.cloneDeep(this.student360Service.lastSelectedCalendarView);
            if (res == 'week' && previousView == 'month') { // If navigating from month view to week view
                // Select the first day in the current month
                this.viewDate = moment(this.viewDate).startOf('month').toDate();
            }
            if (res == 'day' && previousView == 'week') { // If navigating from week view to day view
                // Select the first day in the current week
                this.viewDate = moment(this.viewDate).startOf('week').add(1, 'day').toDate();
            }
            this.calendarHeader.viewDateChange.next(this.viewDate);
            this.student360Service.lastSelectedCalendarDate = this.viewDate;
            this.student360Service.lastSelectedCalendarView = this.view;
            switch (res) {
                case 'day':
                    this.scalePDF = 0.60;
                    break;
                case 'week':
                    this.scalePDF = 0.25;
                    break;
                case 'month':
                    this.scalePDF = 0.40;
                    break;
            }
        });
        this.calendarHeader.viewDateChange.subscribe(viewDate => {
            // Get the date of the first event in the studentCalendar
            const startDate = moment(this.studentCalendar[0].Id, 'YYYY/M/D');
            const endDate = moment(this.studentCalendar[this.studentCalendar.length - 1].Id, 'YYYY/M/D');
            // check if the new view date falls in this range
            const inRange = moment(viewDate).isBetween(startDate, endDate);
            this.student360Service.lastSelectedCalendarDate = this.viewDate;
            this.student360Service.lastSelectedCalendarView = this.view;
            this.selectedDate = viewDate;
            if (!inRange) {
                this.getCalendarEvents();
            } else if (this.view == 'month') {
                this.getCalendarEvents();
            }
        });
    }

    ngOnDestroy() {
        // Clean up
    }

    checkAttendance(dayEvent) {
        const event = dayEvent.event.meta.event;
        if (event.AttendanceId > 0) {
            if (event.AttendanceStatus == null || event.AttendanceStatus == 'Present') {
                return false;
            } else {
                return true;
            }
        }
    }

    checkAttendanceEvents(day) {
        let hasAttendanceEntries = false;
        for (let i = 0; i < day.events.length; i++) {
            const eventOfInterest = day.events[i].meta;
            if (eventOfInterest.eventType == 'dailyScheduleEvent') {
                // Check if it has any attendance entries
                if (eventOfInterest.event.AttendanceId > 0 && (eventOfInterest.event.AttendanceStatus != null || eventOfInterest.event.AttendanceStatus != 'Present')) {
                    hasAttendanceEntries = true;
                }
            }
        }
        return hasAttendanceEntries;
    }

    checkDisciplineEvents(day) {
        let hasDisciplineEvents = false;
        for (let i = 0; i < day.events.length; i++) {
            const eventOfInterest = day.events[i].meta;
            if (eventOfInterest.eventType == 'disciplineEvent') {
                hasDisciplineEvents = true;
            }
        }
        return hasDisciplineEvents;
    }

    checkAssignmentEvents(day) {
        let hasAssignmentEntries = false;
        for (let i = 0; i < day.events.length; i++) {
            const eventOfInterest = day.events[i].meta;
            if (eventOfInterest.eventType == 'dailyScheduleEvent') {
                // Check if it has any Assignment entries
                if (eventOfInterest.event.Assignments.length > 0) {
                    hasAssignmentEntries = true;
                }
            }
        }
        return hasAssignmentEntries;
    }

    eventClicked({ event }: { event: CalendarEvent }): void {
        switch (event.meta.eventType) {
            case 'districtEvent':
                this.dialog.open(CalendarEventModalComponent, {
                    minHeight: 300,
                    minWidth: 500,
                    data: event,
                    autoFocus: false
                });
                break;
            case 'dailyScheduleEvent':
                if (this.loginService.LoginSettings.V10 == false) {
                    // We need to always open the modal even if there are no assignments
                    this.dialog.open(CalendarEventModalComponent, {
                        minHeight: 400,
                        minWidth: 750,
                        maxWidth: 750,
                        maxHeight: 400,
                        autoFocus: false,
                        data: event
                    });
                } else {
                    this.dialog.open(CalendarEventModalComponent, {
                        minHeight: 400,
                        minWidth: 750,
                        maxWidth: 750,
                        maxHeight: 400,
                        autoFocus: false,
                        data: event
                    });
                }
                break;
            case 'disciplineEvent':
                this.router.navigateByUrl('/student360/behavior');
                break;
        }
    }

    setFlexDirection(dayEvent) {
        if (dayEvent.height < 55) {
            return 'eventFlexRow';
        } else {
            return 'eventFlexCol';
        }
    }

    setEventColor(dayEvent) {
        switch (dayEvent.event.meta.eventType) {
            case 'districtEvent':
                if (this.view == 'day') {
                    return 'districtEvent';
                } else if (this.view == 'week') {
                    return 'districtEventWeek';
                }
                break;
            case 'dailyScheduleEvent':
                return 'dailyScheduleEvent';
            case 'disciplineEvent':
                return 'disciplineEvent';
        }
    }

    checkForClasses(day) {
        const events = day.events;
        let dayHasClasses = false;
        events.forEach((event) => {
            if (event.meta.eventType == 'dailyScheduleEvent') {
                dayHasClasses = true;
            }
        });
        if (!dayHasClasses) {
            return 'noClasses';
        }
    }

    eventHasTimes(event) {
        const e = event.event.meta.event;
        if (e.StartTime || e.EndTime) {
            return true;
        }
    }

    getCalendarEvents() {
        this.events = [];
        this.studentCalendar = [];
        const month = this.selectedDate.getUTCMonth() + 1;
        const year = this.selectedDate.getUTCFullYear();
        this.calendarService.getCalendarEvents(this.studentService.selectedStudent.Id, this.yearService.student360Year.Id, this.userService.userId, year + '/' + month).subscribe(results => {
            this.studentCalendar = results;
            this.dateIndex = this.studentCalendar.findIndex(d => d.Id == moment(this.selectedDate, 'YYYY/M/D').format('YYYY/M/D'));
            // Add items from daily schedule if our school policy allows
            let portals: Portal[] = [];
            if (this.userService.userType == 1) {
                portals = this.classroom360Service.staffAssignedPortals;
            } else {
                portals = this.student360Service.parentAssignedPortals;
            }
            if (this.userService.userType == 1) { // If staff member
                // Filter out the portals based on group.
                const myStudentsGroup = portals.filter(p => p.GroupName == 'My Students');
                if (myStudentsGroup.length > 0) { // User is a teacher
                    portals = myStudentsGroup;
                } else { // user is an admin
                    portals = portals.filter(p => p.GroupName == 'Students');
                }
            }
            const studentSchedulePortal = portals.find((p) => p.PortalName == 'Student Schedule');
            if (studentSchedulePortal) {
                for (let i = 0; i < this.studentCalendar.length; i++) {
                    for (let x = 0; x < this.studentCalendar[i].DailySchedule.length; x++) {
                        const date = moment(this.studentCalendar[i].DailySchedule[x].Date);
                        const startTime = moment(this.studentCalendar[i].DailySchedule[x].StartTime, ['h:mm A']);
                        const endTime = moment(this.studentCalendar[i].DailySchedule[x].EndTime, ['h:mm A']);
                        const day = this.studentCalendar.find(d => d.Id == this.studentCalendar[i].Id);
                        const courseInfo = day.Courses.find(course => course.Id === this.studentCalendar[i].DailySchedule[x].Id);
                        const assignmentsCourse = this.studentCalendar[i].Courses.filter(c => c.Id == this.studentCalendar[i].DailySchedule[x].Id)[0];
                        if (assignmentsCourse != undefined && assignmentsCourse.CalendarAssignments != null && assignmentsCourse.CalendarAssignments.length > 0) {
                            this.studentCalendar[i].DailySchedule[x].Assignments = assignmentsCourse.CalendarAssignments;
                        }
                        this.events.push({
                            title: this.studentCalendar[i].DailySchedule[x].CourseName,
                            start: moment(date).add(startTime.hour(), 'hour').add(startTime.minute(), 'minute').toDate(),
                            end: moment(date).add(endTime.hour(), 'hour').add(endTime.minute(), 'minute').toDate(),
                            id: this.studentCalendar[i].DailySchedule[x].Id,
                            meta: {
                                eventType: 'dailyScheduleEvent',
                                event: this.studentCalendar[i].DailySchedule[x],
                                courseInfo: courseInfo
                            }
                        });
                    }
                }
            }
            // Add items from events
            for (let i = 0; i < this.studentCalendar.length; i++) {
                for (let x = 0; x < this.studentCalendar[i].Events.length; x++) {
                    // Check for the event in the list of events to prevent duplication of multi day events
                    const mEvent = this.events.find(ev => ev.id === this.studentCalendar[i].Events[x].Id && ev.title === this.studentCalendar[i].Events[x].Title);
                    if (mEvent == undefined) {
                        if (this.checkAllDayEvent(this.studentCalendar[i].Events[x])) {
                            this.events.push({
                                title: this.studentCalendar[i].Events[x].Title,
                                start: moment(this.studentCalendar[i].Events[x].StartDate).toDate(),
                                end: moment(this.studentCalendar[i].Events[x].EndDate).toDate(),
                                id: this.studentCalendar[i].Events[x].Id,
                                meta: { eventType: 'districtEvent', event: this.studentCalendar[i].Events[x] },
                                allDay: true
                            });
                        } else {
                            const startTime = moment(this.studentCalendar[i].Events[x].StartTime, ['hh:mm A']);
                            const endTime = moment(this.studentCalendar[i].Events[x].EndTime, ['hh:mm A']);
                            const startDate = moment(this.studentCalendar[i].Events[x].StartDate, 'YYYY-MM-DDTHH:mm:ss');
                            const endDate = moment(this.studentCalendar[i].Events[x].EndDate, 'YYYY-MM-DDTHH:mm:ss');
                            const start = moment(startDate).add(startTime.hour(), 'hour').add(startTime.minute(), 'minute').toDate();
                            const end = moment(endDate).add(endTime.hour(), 'hour').add(endTime.minute(), 'minute').toDate();
                            this.events.push({
                                title: this.studentCalendar[i].Events[x].Title,
                                start: start,
                                end: end,
                                id: this.studentCalendar[i].Events[x].Id,
                                meta: { eventType: 'districtEvent', event: this.studentCalendar[i].Events[x] },
                                allDay: false
                            });
                        }
                    }
                }
            }
            // Add items from Discipline
            for (let i = 0; i < this.studentCalendar.length; i++) {
                for (let x = 0; x < this.studentCalendar[i].Discipline.length; x++) {
                    this.events.push({
                        title: this.studentCalendar[i].Discipline[x].Incident,
                        start: moment(this.studentCalendar[i].Discipline[x].DateTime).toDate(),
                        meta: { eventType: 'disciplineEvent', event: this.studentCalendar[i].Discipline[x] }
                    });
                }
            }
            this.refresh.next();
        });
    }

    getTimeString(event) {
        let startTime = '';
        let endTime = '';
        if (event.meta.event.StartTime) { // If there is a start time
            startTime = moment(event.meta.event.StartTime, 'hh:mm A').format('h:mm A').toString();
        }
        if (event.meta.event.EndTime) { // If there is an end time
            endTime = moment(event.meta.event.EndTime, 'hh:mm A').format('h:mm A').toString();
        }
        if (!startTime && !endTime) { // No Start or End Time
            return '';
        }
        if (!startTime && endTime) { // No Start Time
            return 'Until ' + endTime;
        }
        if (startTime && !endTime) { // No End Time
            return startTime;
        }
        if (startTime && endTime) { // Start Time and End Time
            return startTime + ' - ' + endTime;
        }
    }

    checkAllDayEvent(event): boolean {
        // An All day event will display at the top of the calendar
        // If an event has a start time and an end time it is not an all day event
        // If an event spans multiple days then it is an all day event
        if (event.StartTime && event.EndTime && moment(event.StartDate).isSame(event.EndDate, 'day')) {
            return false;
        } else {
            return true;
        }
    }

    allDayEvent(event) {
        if (event.event.allDay) {
            return 'all-day-district-event';
        } else {
            return 'day-district-event';
        }
    }

    setFontSize(event, tag) {
        const startTime = event.start;
        const endTime = event.end;
        const d = moment.utc(moment(endTime, 'DD/MM/YYYY HH:mm:ss').diff(moment(startTime, 'DD/MM/YYYY HH:mm:ss'))).format('HH:mm:ss');
        if (moment.duration(d).asMinutes() <= 15) {
            if (tag == 'time') {
                return 'small-event-time-text';
            } else if (tag == 'title') {
                return 'small-event-title-text';
            }
        }
    }

    checkDayForClasses(date: any, timeSegment: boolean) {
        // Look through the student calendar for the date
        const doi = moment(date.date).format('YYYY/M/D');
        const day = this.studentCalendar.find(d => d.Id == doi);
        // If we find a the date check for classes
        if (day) {
            if (day.DailySchedule.length == 0 && !timeSegment) {
                return 'noClasses';
            }
        }
    }

    log(obj: any) {
        console.log(obj);
    }
}
